import Axios from 'axios'
import {countryUrls} from '../../AmuraService/urls'
import router from '../../../router'

export default {
  get_all_countries (context) {
    Axios.get(countryUrls.getAllCountries).then(function (response) {
      context.commit('GET_ALL_COUNTRIES', response.data)
    })
  },
  get_countries (context, publicId) {
    Axios.get(countryUrls.getCountries + publicId).then(function (response) {
      context.commit('GET_COUNTRIES', response.data)
    })
  },
  get_deleted_countries (context) {
    Axios.get(countryUrls.getDeletedCountry).then(function (response) {
      context.commit('GET_DELETED_COUNTRIES', response.data)
    })
  },
  get_country (context, publicId) {
    Axios.get(countryUrls.getCountry + publicId).then(function (response) {
      context.commit('GET_COUNTRY', response.data)
    })
  },
  post_country (context, data) {
    Axios.post(countryUrls.postCountry, data).then(function () {
      context.dispatch('get_all_countries')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_country (context, data) {
    Axios.post(countryUrls.editCountry, data).then(function () {
      context.dispatch('get_all_countries')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_country (context, publicId) {
    Axios.get(countryUrls.deleteCountry + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_COUNTRIES', response.data)
      router.push({
        name: 'Module.DeletedCountries'
      })
    })
  },
  restoreCountry (context, publicId) {
    Axios.get(countryUrls.restoreCountry + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_COUNTRIES', response.data)
      router.push({
        name: 'Module.Countries'
      })
    })
  }
}
